import type { Paths } from '@epilot/analytics-client'
import { getClient } from '@epilot/analytics-client'
import type { Components } from '@epilot/analytics-client/dist/openapi'
import type { OperationResponse } from 'openapi-client-axios'

import { configureClient } from '../utils/api-utils'
import { ANALYTICS_API_BASE_URL } from '../utils/config'

let cachedClient: ReturnType<typeof getClient>

type PublicToken = string | null | undefined

type SessionId = string

export type Session = Components.Schemas.Session

export const getAnalyticsClient = () => {
  if (!cachedClient) {
    cachedClient = getClient()

    cachedClient = configureClient(cachedClient, {
      baseURL: ANALYTICS_API_BASE_URL
    })
  }

  return cachedClient
}

export const createSession = (
  token: PublicToken,
  payload: Paths.CreateSession.RequestBody
): OperationResponse<Paths.CreateSession.Responses.$202> => {
  const client = getAnalyticsClient()

  return client.createSession(undefined, payload, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
}

export const track = (
  token: PublicToken,
  sessionId: SessionId,
  event: Paths.AddEvents.RequestBody
) => {
  const client = getAnalyticsClient()

  client.addEvents(
    {
      sessionId
    },
    event,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )
}

export const endSession = (
  token: PublicToken,
  sessionId: SessionId,
  payload: Paths.UpdateSession.RequestBody
): OperationResponse<Paths.UpdateSession.Responses.$202> => {
  const client = getAnalyticsClient()

  return client.updateSession({ sessionId }, payload, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
}
